import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=0c439532&"
import script from "./DropFile.vue?vue&type=script&lang=js&"
export * from "./DropFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports